import { render, staticRenderFns } from "./TradeAgainDialog.vue?vue&type=template&id=4240e8e9&scoped=true&"
import script from "./TradeAgainDialog.vue?vue&type=script&lang=js&"
export * from "./TradeAgainDialog.vue?vue&type=script&lang=js&"
import style0 from "./TradeAgainDialog.vue?vue&type=style&index=0&id=4240e8e9&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240e8e9",
  null
  
)

export default component.exports